import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ErrorStateService {
  public errorMessage = signal<string | null>(null);
}
